// PRC-027: Planificación durante la prueba. Explica qué es y que se activa al
// contratar (piezas del recorrido, PRC-015); sin redirección silenciosa.
import React from 'react';
import { Box } from '@mui/material';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { Eyebrow, JourneyButton, JourneyCard, JourneyChip, JourneyText } from './JourneyBasics';
import { StateIcon } from './JourneyBlocks';
import OriginBackLink from './OriginBackLink';
import { J } from '../journeyTokens';

const POINTS = [
  { t: 'Demanda prevista', d: 'Cuánto venderás de cada producto y a cada cliente en los próximos meses, según tu histórico.' },
  { t: 'Facturación planificada', d: 'Ingresos esperados por periodo y su comparación con lo que ya ha ocurrido.' },
  { t: 'Impacto de tus precios', d: 'Qué cambia en volumen e ingresos si aplicas los precios que has evaluado.' },
];

const PlanningTrialPanel: React.FC = () => {
  const { isPricingAdmin } = useAuth();
  const navigate = useNavigate();
  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 4, maxWidth: 1040, display: 'flex', flexDirection: 'column', gap: 3, fontFamily: J.font }}>
      <OriginBackLink sx={{ mb: 0 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px', maxWidth: 720 }}>
        <StateIcon tone="info"><AssessmentOutlinedIcon /></StateIcon>
        <Eyebrow>Planificación</Eyebrow>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <JourneyText variant="title">Planificación de demanda</JourneyText>
          <JourneyChip tone="amber">Growth</JourneyChip>
        </Box>
        <JourneyText variant="lead">
          Proyecta demanda y facturación a partir de tu histórico de ventas. No está incluida en la prueba: se activa al contratar Growth o Autonomy, con los mismos datos que ya has cargado.
        </JourneyText>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0,1fr))' }, gap: 2 }}>
        {POINTS.map((p) => (
          <JourneyCard key={p.t} tight sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <JourneyText variant="h3">{p.t}</JourneyText>
            <JourneyText variant="small">{p.d}</JourneyText>
          </JourneyCard>
        ))}
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center' }}>
        {isPricingAdmin
          ? <JourneyButton onClick={() => navigate('/subscription')}>Ver planes</JourneyButton>
          : <JourneyText variant="small">El administrador de tu cuenta puede activarla al contratar un plan.</JourneyText>}
        <JourneyButton kind="ghost" onClick={() => navigate('/margin-center/overview')}>Ir a Overview</JourneyButton>
      </Box>
    </Box>
  );
};

export default PlanningTrialPanel;
